<template src="./index.html"></template>
<script>
import { getdata } from './data.js';
import {
	managementExpage,
	policypage,
	fxjk_mxcx,
	fxjk_sbmccx,
	fxjk_ysgzbmcx,
	fxjk_save,
	fxjk_getPolicyInfo,
	fxjk_comapny,
	fxjk_delete,
	fxjk_calculation,
	queryCompanyShuibDict,
	managementExExport,
	calculationAgain,
	editIndexPeriod,
    indicatorValue,
	showIndicatorValueHistory,
} from '../../../../api/Notificationsettings.js';
import { zcfg_fycx } from '../../../../api/zcfg.js';
import config from '../../../../../configHttp.js';
export default {
	name: 'fxjk',
	components: {},
	data: function() {
		return {
			//添加政策
			searchdatazc: {},
			searchlistzc: getdata().searchlistzc,
			headDatazc: getdata().headDatazc,
			tableDatazc: [],
			addzcdiag: false,
			paginationzc: getdata().paginationzc,
			//
			mxchaxkuang: '',
			selectfxjk: false,
			selectId: 0,
			addsbmc: false,
			addxzmx: false,
			addfxjk: false, //控制风险监控新增
			shaidiag: true,
			tableData: [],
			tableDataHistory:[], //表格数据
			headData: getdata().headData, //表格导航栏数据
			sjlydiag: false,
			ywdiag: false,
			pagination: getdata().pagination,
			paginationxzmx: getdata().paginationxzmx,
			paginationHistory:getdata().paginationHistory,
			searchlist: getdata().searchlist, //搜索栏数据
			searchdiag: false,
			searchdata: getdata().searchdata,
			searchdataxzmx: getdata().searchdataxzmx,
			ruleForm: {
				test1: '',
				test2: '',
				test3: '',
				test4: '',
				test5: ''
			},
			zbdldata: getdata().zbdldata,
			yjvaluedata: getdata().yjvaluedata,
			boldata: getdata().boldata,
			options: [],
			value: '',
			zbdlData: [],
			name: '',
			zbdl: getdata().zbdlData,
			zbdlvalue: '',
			//
			xinzhen: {
				id: '',
				select: {
					zbdlvalue: '',
					zbleb: '',
					yjvalue: '',
					number: ''
				},
				baocunzhancun: {
					shenbaozonglei: [],
					tianjiazhengc: []
				},
				radio: '1',
				zhibiaomincheng: '',
				shuzhi: {
					shuzhi: '',
					qujianqian: '',
					qujianho: ''
				},
				baifbi: {
					baifbiqian: '',
					baifbiho: ''
				},
				mx: {},
				duiyingchelue: '',
				calculationFormula:'',
				nowValue:'',
			},
			//
			// szData: [{}, {}]
			suibiaomcData: getdata().suibiaomcData,
			tableDataHistory:getdata().tableDataHistory,
			suibiaomc: getdata().suibiaomc,
			xzmxbt: getdata().xzmxbt,
			historyData: getdata().historyData,
			xzmxData: [],
			radioval: null,
			tablekey: 0,
			overlength: 0,
			suosq: this.$getdefultMonth(),
			formlist:getdata().formlist,
			bjzbz_show:false,
			bjzbz_data:{
				id:'',
				samePeriodLastYearUserValue:'',
				// thisUserPeriod:'',
                benqlj:'',
			},
			updataBjzb:false,
		};
	},
	mounted() {},
	created() {
		this.chaxgs();
		this.getShuizList();
	},
	methods: {
		bjzbz_new(){
			let params = JSON.parse(JSON.stringify(this.bjzbz_data))
			indicatorValue(params).then(res=>{
				 if(res.data.code==1){
					this.bjzbz_show = false
					this.chaxgs(1);
				}else{
					this.$message.error(res.data.msg)
				}
			})
		},
		bjzbz(e){
			Object.keys(this.bjzbz_data).forEach(key=>{
                console.log(!e[key]);
				if(!e[key] || e[key] == null){
					this.bjzbz_data[key] = ''
				}else if(e[key]){
					this.bjzbz_data[key] = e[key]
				}
			})
            this.bjzbz_data = JSON.parse(JSON.stringify(this.bjzbz_data))
            // console.log(this.bjzbz_data)
			this.bjzbz_show = true
			let id = this.bjzbz_data.id
			this.selectId = id
			this.showHistory(id);
		},
		geOoverLength(e){
		  this.overlength = e;
	  	},
		showHistory(e){
			let params = {
				id: e
			};
			params.current = this.paginationHistory.pageNum;
			params.size = this.paginationHistory.pageSize;
			params.sort = '';
			params.order = '';

			console.log(params);
			showIndicatorValueHistory(params).then(res=>{
				 if(res.data.code==1){
					this.tableDataHistory = res.data.data;
					this.paginationHistory.total = res.data.data.total;
					this.tableDataHistory = res.data.data.records;
				}else{
					this.$message.error(res.data.msg)
				}
			})
		},
		BatchExport() {
			let list = this.$refs.tablebox.getSelectionval()
			let ids = []
			if(list.length>0){
				list.map(item=>{
					ids.push(item.id)
				})
			}
			let params = {
				downUrl: config.baseURL + '/managementEx/export',
				typeObj: {
					toForm: false,
					fileType: 'xlsx',
					failUrl:this.$winURl
				},
				params: { ...this.searchdata, suosq: this.suosq,companyCode: this.value,ids}
			};
			this.$downloadcommon(params);
		},
		cxjs() {
			var chooseitem = this.$refs.tablebox.getSelectionval();
			if (this.$emptyandnull(chooseitem)) {
				this.$message.error('请选择数据');
				return false;
			}
			let params = {
				companyCode: this.value,
				indexNos: chooseitem.map(item => item.indexNo),
				ids: chooseitem.map(item => item.id),
				suosq: this.suosq
			};
			calculationAgain(params).then(res => {
				this.pagination.pageNum = 1;
				this.pagination.paginationkey++;
				this.balancePage();
			});
		},
		fkjs() {
			var chooseitem = this.$refs.tablebox.getSelectionval();
			if (this.$emptyandnull(chooseitem)) {
				this.$message.error('请选择数据');
				return false;
			}
			let params = {
				companyCode: this.value,
				indexNos: chooseitem.map(item => item.indexNo),
				ids: chooseitem.map(item => item.id),
				suosq: this.suosq
			};
			fxjk_calculation(params).then(res => {
				this.pagination.pageNum = 1;
				this.pagination.paginationkey++;
				this.balancePage();
			});
		}, //新增弹框
		getShuizList() {
			queryCompanyShuibDict().then(res => {
				this.searchlist.forEach(item => {
					if (item.prop == 'shuibId') {
						item.selectval = res.data.data.map(item => {
							return {
								label: item.reportName,
								value: item.id
							};
						});
					}
				});
				let newarr = JSON.parse(JSON.stringify(this.searchlist));
				this.searchlist = newarr;
			});
		},
		xingzheng() {
			this.xinzhen = {
				id: '',
				select: {
					zbdlvalue: '',
					zbleb: '',
					yjvalue: '',
					number: ''
				},
				baocunzhancun: {
					shenbaozonglei: [],
					tianjiazhengc: []
				},
				radio: '1',
				zhibiaomincheng: '',
				shuzhi: {
					shuzhi: '',
					qujianqian: '',
					qujianho: ''
				},
				baifbi: {
					baifbiqian: '',
					baifbiho: ''
				},
				mx: {},
				duiyingchelue: '',
				calculationFormula:'',
				nowValue:'',
			};
			this.addfxjk = true;
			this.updataBjzb = false
		},
		currStationChange(v) {
			this.pagination.pageNum = 1;
			this.pagination.paginationkey++;
			this.balancePage();
		},
		//编辑 查看
		bianji(e, k) {
			let params = {
				id: e.id
			};
			this.xinzhen.id = e.id;
			fxjk_getPolicyInfo(params).then(res => {
				this.xinzhen.select.zbdlvalue = res.data.data.category;
				this.xinzhen.radio = res.data.data.enable;

				if (res.data.data.type != null) {
					this.xinzhen.select.zbleb = res.data.data.type.toString();
				}
				this.xinzhen.zhibiaomincheng = res.data.data.name;
				this.xinzhen.valveValue = res.data.data.valveValue;

				if (res.data.data.valueType != null) {
					this.xinzhen.select.yjvalue = res.data.data.valueType.toString();
				}

				if (res.data.data.valueJsType != null) {
					this.xinzhen.select.number = res.data.data.valueJsType.toString();
				}
				this.xinzhen.mx.yewkmCode = res.data.data.indexNo;
				this.xinzhen.mx.yewkmCodeyewkmName = res.data.data.manageModel;
				this.xinzhen.mx.description = res.data.data.modelDesc;
				this.xinzhen.baocunzhancun.shenbaozonglei = res.data.data.shuibList;
				this.xinzhen.baocunzhancun.tianjiazhengc = res.data.data.zcList;
				this.xinzhen.duiyingchelue = res.data.data.yidcl;
				this.xinzhen.nowValue = res.data.data.nowValue;
				this.xinzhen.calculationFormula = res.data.data.calculationFormula;
				if (res.data.data.valueType == 1) {
					this.xinzhen.baifbi.baifbiqian = res.data.data.valueStart;
					this.xinzhen.baifbi.baifbiho = res.data.data.valueEnd;
				} else {
					if (this.xinzhen.select.number > 2) {
						this.xinzhen.shuzhi.shuzhi = res.data.data.valueStart;
					} else {
						this.xinzhen.shuzhi.qujianqian = res.data.data.valueStart;
						this.xinzhen.shuzhi.qujianho = res.data.data.valueEnd;
					}
				}
				if (k == 1) {
					this.addfxjk = true;
					this.updataBjzb = true
				} else {
					this.selectfxjk = true;
				}

			});
		},
		//新增风险
		fxianbaoc() {
			let params = {};
			params.category = this.xinzhen.select.zbdlvalue;
			params.enable = this.xinzhen.radio;
			params.type = this.xinzhen.select.zbleb;
			params.name = this.xinzhen.zhibiaomincheng;
			params.valueType = this.xinzhen.select.yjvalue;
			params.valueJsType = this.xinzhen.select.number;
			if (params.valueType == 1) {
				params.valueStart = this.xinzhen.baifbi.baifbiqian;
				params.valueEnd = this.xinzhen.baifbi.baifbiho;
			} else {
				if (this.xinzhen.select.number > 2) {
					params.valueStart = this.xinzhen.shuzhi.shuzhi;
				} else {
					params.valueStart = this.xinzhen.shuzhi.qujianqian;
					params.valueEnd = this.xinzhen.shuzhi.qujianho;
				}
			}
			if(this.xinzhen.nowValue != ''){
				params.nowValue = this.xinzhen.nowValue;
			}
			params.indexNo = this.xinzhen.mx.yewkmCode;
			if (this.xinzhen.mx.yewkmCodeyewkmName == undefined || this.xinzhen.mx.yewkmCodeyewkmName == null || this.xinzhen.mx.yewkmCodeyewkmName == '') {
				this.$message.info('请选择模型');
				return;
			}
			params.manageModel = this.xinzhen.mx.yewkmCodeyewkmName;
			params.modelDesc = this.xinzhen.mx.description;
			params.shuibList = this.xinzhen.baocunzhancun.shenbaozonglei.map(v => v.id);
			params.zcList = this.xinzhen.baocunzhancun.tianjiazhengc.map(v => v.id);
			params.yidcl = this.xinzhen.duiyingchelue;
			params.id = this.xinzhen.id;
			params.calculationFormula = this.xinzhen.calculationFormula;
			params.companyCode = this.value;
			params.suosq = this.suosq;
			fxjk_save(params).then(res => {
				if (res.data.code == 1) {
					this.addfxjk = false;
					this.pagination.pageNum = 1;
					this.pagination.paginationkey++;
					this.balancePage();
				} else if (res.data.code == 'NsRISO010') {
					this.$message.error('指标名称重复');
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		//添加政策
		addzc() {
			let selectVal = this.$refs.tableboxzc.getSelectionval();
			this.xinzhen.baocunzhancun.tianjiazhengc = selectVal;
			this.addzcdiag = false;
		},
		//政策查询接口
		fetchResultShow() {
			let params = JSON.parse(JSON.stringify(this.searchdatazc));
			params.current = this.paginationzc.pageNum;
			params.size = this.paginationzc.pageSize;
			params.sort = '';
			params.order = '';
			// params.search = ;
			zcfg_fycx(params).then(res => {
				this.paginationzc.total = res.data.data.total;
				this.tableDatazc = res.data.data.records;
			});
		},
		submitSearchzc() {
			this.paginationzc.pageNum = 1;
			this.paginationzc.paginationkey++;
			this.fetchResultShow();
		},

		sizechangezc(e) {
			this.paginationzc.pageSize = e;
			this.fetchResultShow();
		},
		currentChangezc(e) {
			this.paginationzc.pageNum = e;
			this.fetchResultShow();
		},

		//添加政策弹框
		addzcdiagff() {
			let params = {};
			params.current = this.paginationzc.pageNum;
			params.size = this.paginationzc.pageSize;
			params.sort = '';
			params.order = '';
			// params.search = ;
			zcfg_fycx(params).then(res => {
				this.paginationzc.total = res.data.data.total;
				this.tableDatazc = res.data.data.records;
				this.addzcdiag = true;
			});
			// this.fetchResultShow();
		},
		//添加政策删除
		spliceywfdiag(k) {
			this.xinzhen.baocunzhancun.tianjiazhengc.splice(k, 1);
		},
		//关联申报种类弹框查询
		shenbaozl() {
			let data = {
				size: 9999
			};
			fxjk_sbmccx(data).then(res => {
				if (res.data.code == 1) {
					this.suibiaomcData = res.data.data.records;
					this.addsbmc = true;
					this.$nextTick(() => {
						this.$refs.tableboxsbmc.toggleSelection(
							this.suibiaomcData.filter(item => this.xinzhen.baocunzhancun.shenbaozonglei.map(gtem => gtem.id).includes(item.id))
						);
					});
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		//关联申报种类保存
		addData() {
			let selectVal = this.$refs.tableboxsbmc.getSelectionval();
			this.xinzhen.baocunzhancun.shenbaozonglei = selectVal;
			this.addsbmc = false;
		},
		//删除关联申报种类
		shancsbaozl(k) {
			this.xinzhen.baocunzhancun.shenbaozonglei.splice(k, 1);
		},
		sizechange(e) {
			this.pagination.pageSize = e;
			this.balancePage();
		},
		sizechangeHistory(e) {
			this.paginationHistory.pageSize = e;
			this.showHistory(this.selectId);
		},
		submitSearch() {
			this.pagination.pageNum = 1;
			this.pagination.paginationkey++;
			this.balancePage();
		},
		currentChange(e) {
			this.pagination.pageNum = e;
			this.balancePage();
		},
		currentChangeHistory(e) {
			this.paginationHistory.pageNum = e;
			this.showHistory(this.selectId);
		},
		chaxgs(e) {
			fxjk_comapny().then(res => {
				this.options = res.data.data.map(v => {
					return {
						value: v.companyCode,
						label: v.nsrmc
					};
				});
				if(!e){
					this.value = this.options[0].value;
				}
				this.balancePage();
			});
		},
		balancePage() {
			let params = JSON.parse(JSON.stringify(this.searchdata));
			params.companyCode = this.value;
			params.suosq = this.suosq;
			params.current = this.pagination.pageNum;
			params.size = this.pagination.pageSize;
			managementExpage(params).then(res => {
				if (res.data.code == 1) {
					this.tableData = res.data.data;
					this.pagination.total = res.data.data.total;
					this.tableData = res.data.data.records;
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},

		sizechangexzmx(e) {
			this.paginationxzmx.pageSize = e;
			this.balancePagexzmx();
		},
		submitSearchxzmx() {
			this.paginationxzmx.pageNum = 1;
			this.paginationxzmx.paginationkey++;
			this.balancePagexzmx();
		},
		currentChangexzmx(e) {
			this.paginationxzmx.pageNum = e;
			this.balancePagexzmx();
		},
		ysbhchax() {
			this.balancePagexzmx();
		},
		mxsskcx() {
			this.balancePagexzmx();
		},
		ysgzbmcx() {
			let params = {};
			params.companyCode = this.value;
			fxjk_ysgzbmcx(params).then(res => {
				this.zbdlData = res.data.data.records;
				this.zbdlvalue = this.zbdlData[0].id;
				this.name = this.zbdlData[0].ruleNum;
				this.balancePagexzmx();
			});
		},
		balancePagexzmx() {
			// let params = JSON.parse(JSON.stringify(this.searchdataxzmx));
			let params = {};
			params.current = this.paginationxzmx.pageNum;
			params.size = this.paginationxzmx.pageSize;
			params.sort = '';
			params.order = '';
			params.ruleId = this.zbdlvalue;
			params.searchKey = this.mxchaxkuang;
			fxjk_mxcx(params).then(res => {
				if (res.data.code == 1) {
					this.paginationxzmx.total = res.data.data.total;
					this.xzmxData = res.data.data.records;
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		xuanzheimx() {
			this.ysgzbmcx();
			this.addxzmx = true;
			this.mxchaxkuang = ''
		},
		moxingbaoc() {
			this.xzmxData.forEach(v => {
				if (this.radioval == v.id) {
					this.xinzhen.mx = v;
					this.xinzhen.mx.yewkmCodeyewkmName = v.yewkmCode + ' --- ' + v.yewkmName;
				}
			});
			this.addxzmx = false;
		},
		//删除按钮
		deleteData() {
			var chooseitem = this.$refs.tablebox.getSelectionval();
			if (this.$emptyandnull(chooseitem)) {
				this.$message.error('请选择数据');
				return false;
			}
			let params = chooseitem.map(item => item.id);
			this.$showConfirm({
				message: '确认删除?'
			}).then(res => {
				if (res == 'confirm') {
					fxjk_delete(params).then(res => {
						if (res.data.code == 1) {
							this.$message.success('删除成功');
							this.pagination.pageNum = 1;
							this.pagination.paginationkey++;
							this.balancePage();
						} else {
							this.$message.error(res.data.msg);
						}
					});
				}
			});
		},
		forseejcxinxi() {},
		closediagywdiag() {
			this.ywdiag = false;
		},
		forUpdateSearch() {
			this.searchdiag = true;
		},
		closeSearch() {
			this.searchdiag = false;
		},
		saveChange(e) {
			this.searchdiag = false;
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
